"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactSizeme = require("react-sizeme");

var _reactApollo = require("react-apollo");

var _commonReact = require("@devsta/common-react");

var _GeneralInfo = _interopRequireDefault(require("../components/GeneralInfo"));

var _api = require("../api");

var _api2 = require("../../../../../common/api");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function GeneralInfo(_ref) {
  var video = _ref.video,
      assets = _ref.assets,
      updateVideoData = _ref.updateVideoData;
  var outputs = video.outputs;

  var _outputs$find = outputs.find(function (_ref2) {
    var isMaster = _ref2.isMaster;
    return isMaster;
  }),
      assignedEditorId = _outputs$find.assignedEditorId;

  return /*#__PURE__*/_react.default.createElement(_reactApollo.ApolloConsumer, null, function (apolloClient) {
    return /*#__PURE__*/_react.default.createElement(_commonReact.RequestProvider, {
      requests: _objectSpread({
        getOrganisation: (0, _api.getOrganisationApi)(video.organisationId),
        getCreator: (0, _api.getUserApi)(video.createdByUserId),
        updateOutput: _api2.updateOutput
      }, assignedEditorId ? {
        getEditor: (0, _api.getUserApi)(assignedEditorId)
      } : {})
    }, function (requests) {
      return /*#__PURE__*/_react.default.createElement(_reactSizeme.SizeMe, null, function (_ref3) {
        var size = _ref3.size;
        return /*#__PURE__*/_react.default.createElement(_GeneralInfo.default, _extends({
          containerSize: size,
          apolloClient: apolloClient,
          updateVideoData: updateVideoData,
          video: video,
          assets: assets
        }, requests));
      });
    });
  });
}

var _default = (0, _react.memo)(GeneralInfo);

exports.default = _default;